import React from "react";
import { inr } from "../utils/coords";
import SaveBadge from "./ui/SaveBadge";
import HealBadge from "./ui/HealBadge";
import UserBadge from "./ui/UserBadge";

/**
 * Header — top application bar.
 * Shows: J.A.D.E logo · project name · total cost
 *        + panel toggles (Layers, Properties) · heal badge · save badge · user
 */
export default function Header({
  project, saveStatus, healLog, onHealOpen, onProjectEdit, boq, user,
  // Panel toggles
  showLayerPanel, onToggleLayers,
  showProps,      onToggleProps,
  showCmdLine,    onToggleCmdLine,
}) {
  const mono = { fontFamily: "'JetBrains Mono','Fira Code',monospace" };
  const div  = <div style={{ width:1, background:"#0d1520", height:18 }}/>;

  return (
    <div style={{
      height:36, background:"#020a14", borderBottom:"1px solid #0a1828",
      display:"flex", alignItems:"center", padding:"0 10px", gap:8,
      flexShrink:0, zIndex:20, ...mono,
    }}>

      {/* Brand */}
      <span style={{ fontSize:8, color:"#1e3a5a", letterSpacing:3, fontWeight:800 }}>
        J.A.D.E
      </span>

      {div}

      {/* Project name */}
      <button onClick={onProjectEdit}
        style={{ background:"transparent", border:"none", cursor:"pointer",
          padding:0, display:"flex", alignItems:"baseline", gap:6 }}>
        <span style={{ fontSize:12, fontWeight:700, color:"#dde6f0", letterSpacing:-0.3 }}>
          {project.name || "Untitled"}
        </span>
        {project.client && (
          <span style={{ fontSize:8.5, color:"#2a3a4a" }}>{project.client}</span>
        )}
        <span style={{ fontSize:8, color:"#1e2a36" }}>✎</span>
      </button>

      {div}

      {/* Total cost */}
      <div style={{ display:"flex", alignItems:"baseline", gap:5 }}>
        <span style={{ fontSize:7.5, color:"#3d5068", letterSpacing:1 }}>TOTAL</span>
        <span style={{ fontSize:16, fontWeight:800, color:"#e8a838", letterSpacing:-0.5 }}>
          {inr(boq?.totalCost || 0)}
        </span>
      </div>

      {boq?.totalCost > 0 && (
        <>
          {div}
          <span style={{ fontSize:8, color:"#3b82f6" }}>
            {inr(boq.wallCost + boq.labourCost)} str
          </span>
          <span style={{ fontSize:8, color:"#4ade80" }}>
            {inr(boq.roomCost)} fin
          </span>
        </>
      )}

      <div style={{ flex:1 }}/>

      {/* Panel toggle buttons */}
      <div style={{ display:"flex", gap:2 }}>
        <PanelBtn
          active={showLayerPanel} onClick={onToggleLayers}
          title="Toggle Layer Panel (L)" label="Layers"/>
        <PanelBtn
          active={showProps} onClick={onToggleProps}
          title="Toggle Properties Panel" label="Props"/>
        <PanelBtn
          active={showCmdLine} onClick={onToggleCmdLine}
          title="Toggle Command Line (`)" label="CMD"/>
      </div>

      {div}
      <HealBadge healLog={healLog} onOpen={onHealOpen}/>
      <SaveBadge status={saveStatus}/>
      {div}
      <UserBadge user={user}/>
    </div>
  );
}

function PanelBtn({ active, onClick, title, label }) {
  return (
    <button title={title} onClick={onClick}
      style={{
        padding:"2px 7px", height:22, borderRadius:2,
        background: active ? "#0c1828" : "transparent",
        border:     active ? "1px solid #1e3d6640" : "1px solid #0a1828",
        color:      active ? "#3b82f6" : "#1e2a36",
        fontSize:8, cursor:"pointer",
        fontFamily:"'JetBrains Mono',monospace",
        transition:"all .1s",
      }}>
      {label}
    </button>
  );
}
